import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FeedbackTriagePage } from '@/pages/super-admin/feedback/FeedbackTriagePage';

const searchSchema = z.object({
	ticket: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/super-admin/feedback')({
	component: FeedbackTriagePage,
	validateSearch: searchSchema,
});
